var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.03308H5H21",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.03308V4.03308C8 3.50265 8.21071 2.99394 8.58579 2.61887C8.96086 2.24379 9.46957 2.03308 10 2.03308H14C14.5304 2.03308 15.0391 2.24379 15.4142 2.61887C15.7893 2.99394 16 3.50265 16 4.03308V6.03308M19 6.03308V20.0331C19 20.5635 18.7893 21.0722 18.4142 21.4473C18.0391 21.8224 17.5304 22.0331 17 22.0331H7C6.46957 22.0331 5.96086 21.8224 5.58579 21.4473C5.21071 21.0722 5 20.5635 5 20.0331V6.03308H19Z",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.ef46d81aac1840a1a0c981671376bf84.svg";
export { ForwardRef as ReactComponent };